import React from "react";
import { RouteComponentProps } from "@reach/router";
import { Breakpoint } from "react-socks";
import { useScrollTopOnMount, useStoreAppValue } from "@hooks";
import { OccasionsListQuery, BrandFavoritesDialerQuery, AnnouncementModalQuery } from "@organisms";
import { Box, Container } from "@atoms";
import { DefaultStoreFrontViewQuery } from "../../storeFrontComponents/StoreFrontView";
import { StoreFrontFeaturedBrand } from "../../storeFrontComponents/StoreFrontFeaturedBrand";
import OnboardingWelcomeModalQuery from "../components/OnboardingWelcomeModal/OnboardingWelcomeModalQuery";
import styled from "@emotion/styled";

// == Types ================================================================

// interface IProps {}

// == Constants ============================================================

// == Component ============================================================

const Home = (_props: RouteComponentProps) => {
  useScrollTopOnMount();
  const { featureFlags, campaignId } = useStoreAppValue();

  return (
    <>
      <Container data-testid="container" mt={3} pt={[3, 3, 4]}>
        <EStoreFrontFeaturedBrand isHome campaignId={campaignId} />
        <Breakpoint down small>
          <Box mb={4}>
            <BrandFavoritesDialerQuery />
          </Box>
        </Breakpoint>
        <OccasionsListQuery />
      </Container>
      <DefaultStoreFrontViewQuery type="HOME_DEFAULT" />
      <AnnouncementModalQuery />
      {featureFlags.newOnboarding && <OnboardingWelcomeModalQuery />}
    </>
  );
};

export default Home;

// == Styles ===============================================================

const EStoreFrontFeaturedBrand = styled(StoreFrontFeaturedBrand)`
  margin-bottom: ${({ theme }) => `${theme.space[3]}px`};
  @media only screen and (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    margin-bottom: ${({ theme }) => `${theme.space[4]}px`};
  }
`;
